import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/lib/content";

export default function Solutions() {
  const { SOLUTIONS, IMAGES } = useContent();
  return (
    <>
      <Seo
        title="Solar Energy Solutions | Residential, Commercial, Industrial & Solar Pumps | DHIYAA SOLAR ENERGY"
        description="Customised solar solutions based on electricity consumption, roof/land area, application, budget and future energy requirements — residential, commercial, industrial, on-grid, hybrid, off-grid and solar pump sets."
      />
      <PageHero
        eyebrow="Solar Solutions"
        title="Solar Energy Solutions"
        subtitle="Customised solar solutions based on electricity consumption, available roof/land area, application, budget and future energy requirements."
        image={IMAGES.hero[0]}
      />
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6" data-testid="solutions-grid">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SOLUTIONS.map((s, i) => (
            <Reveal key={s.slug} delay={i * 0.06}>
              <Link
                to={`/solutions/${s.slug}`}
                className="group block h-full overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-sm transition-all hover:-translate-y-1.5 hover:shadow-xl"
                data-testid={`solutions-card-${s.slug}`}
              >
                <div className="relative h-52 overflow-hidden">
                  <img src={s.image} alt={s.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  <div className="absolute inset-0 bg-gradient-to-t from-brand-navy/60 to-transparent" />
                  <span className="absolute bottom-4 left-5 rounded-full bg-brand-orange px-3.5 py-1 text-[11px] font-bold uppercase tracking-wider text-white">
                    {s.name}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-lg font-bold text-brand-navy">{s.title}</h3>
                  <p className="mt-1.5 line-clamp-2 text-sm text-slate-600">{s.intro}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-blue transition-colors group-hover:text-brand-orange">
                    Learn more <ArrowRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
